import { LucidServerAPI } from '~api/api';

// fetch a task
export const getTask = (taskId, useLegacy = true) =>
  LucidServerAPI().get(`/tasks/${taskId}?legacy=${useLegacy}`);
